<template>
  <select v-if="departments.length == 0">
    <option>Loading....</option>
  </select>
  <select v-else @change="$emit('update:modelValue', $event.target.value)" :value="modelValue">
    <option :value="null">Select a Department</option>
    <option v-for="dept of departments" :key="dept.id" :value="dept.id">{{dept.label}}</option>
  </select>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'

export default defineComponent({
  props: {
    modelValue: String,
  },
  emits: ['update:modelValue'],
  setup() {
    const departments = ref<Array<{ id: string | null; label: string }>>([])

    onMounted(() => {
      fetch('https://velocity2.ouapis.org/donation-forms/departments')
        .then((x) => x.json())
        .then((resp) => (departments.value = resp))
    })

    return {
      departments,
    }
  },
})
</script>
<style scoped lang="scss">
select {
  border-radius: 4px;
  border: 1px solid #ddd;
  background-color: #f7f9fb;
  color: #222;
  cursor: pointer;
  width: 100%;
  outline: 0;
  box-sizing: border-box;
  min-width: 80px;
  transition: border-color 0.3s ease-in-out;
  font-size: 16px;
  align-items: center;
  box-shadow: none;
  display: inline-flex;
  height: 44px;
  justify-content: flex-start;
  padding: 0 10px;
  position: relative;
  @media only screen and (min-width: 720px) {
    height: 42px;
  }

  &:hover {
    border-color: $color-blue;
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    border: 1px solid #e4e4e4;
    background: #f3f2f2;
  }
  &:focus {
    border-color: $color-blue;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
  }
}
</style>